module.exports = __webpack_public_path__ + "img/ru.b05b1df3.svg";